export class BestellvorschlagIntern {
    at_id: number;
    artikel_id: number;
    artikel_me: string;
    tierarzt_id: number;
    tierarzt: string;
    mindestbestand: number;
    erstellt: Date;
    editiert: Date;
}
